import _BaseUserProfile from 'Models/UserProfile/_BaseUserProfile';

export default class DrivingLicenseExpDate extends _BaseUserProfile {
  component = 'DateCalendar';
  props = {
    title: 'Expiration Date of Driver’s License:',
    errorMessage: 'Please Select Date',
    additionalFormInModal: false,
  };
}
